import { TranslationType } from "../types";
import { dashboard } from "./de/dashboard";
import { landing } from "./de/landing";
import { story } from "./de/story";
import { common } from "./de/common";
import { settings } from "./de/settings";
import { auth } from "./de/auth";
import { navigation } from "./de/navigation";
import { profile } from "./de/profile";
import { errors } from "./de/errors";

export const de: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
